module.exports = __webpack_public_path__ + "01ea978f/img/arrow-export-icon.a3345173.svg";